import AppLayoutViewPage from './routes/__app/_layout/view';
import AppCustomersIndexViewPage from './routes/__app/customers/_index/view';
import AppCustomersChurnedIndexViewPage from './routes/__app/customers/churned/_index/view';
import AppCustomersLiveIndexViewPage from './routes/__app/customers/live/_index/view';
import AppReferralsIndexViewPage from './routes/__app/referrals/_index/view';
import AppReferralsActiveIndexViewPage from './routes/__app/referrals/active/_index/view';
import AppReferralsActiveComponentsNewReferralDialogmodulePage from './routes/__app/referrals/active/components/NewReferralDialog.module.css';
import AppReferralsActiveComponentsNewReferralDialogPage from './routes/__app/referrals/active/components/NewReferralDialog';
import AppReferralsLostIndexViewPage from './routes/__app/referrals/lost/_index/view';
import AppRevenueshareIndexViewPage from './routes/__app/revenue-share/_index/view';
import AppSettingsParamActiveTabPage from './routes/__app/settings/$activeTab/view';
import AppSettingsIndexViewPage from './routes/__app/settings/_index/view';
import AuthLayoutViewPage from './routes/__auth/_layout/view';
import AuthDirectloginPage from './routes/__auth/direct-login/view';
import AuthLoginPage from './routes/__auth/login/view';
import IndexPage from './routes/_index';
import DownloadPage from './routes/download/view';
import LogoutPage from './routes/logout/view';
import MobileunsupportedPage from './routes/mobile-unsupported/view';
import OnboardingIndexViewPage from './routes/onboarding/_index/view';
import OnboardingLayoutViewPage from './routes/onboarding/_layout/view';

export const router = [{
  "children": [
    {
      "children": [
        {
          "children": [
            {
              "index": true,
              Component: AppCustomersIndexViewPage
            },
            {
              "children": [
                {
                  "index": true,
                  Component: AppCustomersChurnedIndexViewPage
                }
              ],
              "path": "churned"
            },
            {
              "children": [
                {
                  "index": true,
                  Component: AppCustomersLiveIndexViewPage
                }
              ],
              "path": "live"
            }
          ],
          "path": "customers"
        },
        {
          "children": [
            {
              "index": true,
              Component: AppReferralsIndexViewPage
            },
            {
              "children": [
                {
                  "index": true,
                  Component: AppReferralsActiveIndexViewPage
                },
                {
                  "children": [
                    {
                      "path": "NewReferralDialog/module",
                      Component: AppReferralsActiveComponentsNewReferralDialogmodulePage
                    },
                    {
                      "path": "NewReferralDialog",
                      Component: AppReferralsActiveComponentsNewReferralDialogPage
                    }
                  ],
                  "path": "components"
                }
              ],
              "path": "active"
            },
            {
              "children": [
                {
                  "index": true,
                  Component: AppReferralsLostIndexViewPage
                }
              ],
              "path": "lost"
            }
          ],
          "path": "referrals"
        },
        {
          "children": [
            {
              "index": true,
              Component: AppRevenueshareIndexViewPage
            }
          ],
          "path": "revenue-share"
        },
        {
          "children": [
            {
              "path": ":activeTab",
              Component: AppSettingsParamActiveTabPage
            },
            {
              "index": true,
              Component: AppSettingsIndexViewPage
            }
          ],
          "path": "settings"
        }
      ],
      Component: AppLayoutViewPage
    },
    {
      "children": [
        {
          "path": "direct-login",
          Component: AuthDirectloginPage
        },
        {
          "path": "login",
          Component: AuthLoginPage
        }
      ],
      Component: AuthLayoutViewPage
    },
    {
      "index": true,
      Component: IndexPage
    },
    {
      "path": "download",
      Component: DownloadPage
    },
    {
      "path": "logout",
      Component: LogoutPage
    },
    {
      "path": "mobile-unsupported",
      Component: MobileunsupportedPage
    },
    {
      "children": [
        {
          "index": true,
          Component: OnboardingIndexViewPage
        }
      ],
      "path": "onboarding",
      Component: OnboardingLayoutViewPage
    }
  ],
  "path": "/"
}]
